<template>
  <div class="zc">
    <div class="zc-btn-group flex-xb">
      <div
        class="zc-btn flex-xc-yc"
        v-for="(item, index) in table.th"
        :key="index"
      >
        <span>{{ item }}</span>
      </div>
    </div>
    <div class="zc-list-group">
      <div
        class="tr flex-xb flex-yc"
        v-for="(item, index) in table.tr"
        :key="index"
      >
        <div class="td" v-for="(item2, index2) in item" :key="index2">
          {{ item2 }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'zcdx', //政策兑现
  data() {
    return {
      table: {
        th: ['政策名称', '已兑付金额(万元)', '惠及企业(个人)数'],

        tr: [
          ['人才政策', '4166.22', '728'],
          ['科技政策', '40438.9852', '20'],
          ['战新政策', '1628.44', '8'],
          ['农业政策', '214.44', '295'],
          ['文旅政策', '55', '3'],
          ['企业员工补助', '1486.16', '34358'],
          ['外贸政策', '4528.79', '272'],
          ['内贸政策', '1382.276', '40'],

          ['加大留抵退税力度', '185969.34', '4203'],
          ['落实中小微企业减税降费政策', '19733.61', '39981'],
          ['加大服务业增值税抵减', '6572.53', '871'],
          ['减免“房土两税”', '4174.28', '1596'],
          ['延续实行阶段性制造业税费缓缴', '125968.35', '8781'],
          ['降低融资担保费率', '201', '185'],
          ['阶段性降低失业费率', '13896.68', '	27500'],
          ['失业保险稳岗返还', '	1650.6', '3657'],
          ['“2022欢乐红五月·你消费我助力”消费促进活动', '300', '26'],
          ['国企对非国有小微企业及个体工商户减免租金', '9905.97', '1322'],
          ['100%退质保金', '73	', '12'],
          ['医保缓缴', '4.53', '1'],
          ['岗前技能培训补贴（甬保）', '	154.26', '	2571'],
        ],
      },
    }
  },
}
</script>

<style>
.zc {
  padding: 0 15px 45px;
  box-sizing: border-box;
  background: #fff;
  border-radius: 0 0 4px 4px;
}
.zc-btn-group {
  padding: 20px 0 5px;
  box-sizing: border-box;
}
.zc-btn {
  background: #2ec9bb;
  border-radius: 3px;
  padding: 0 0.5em;
  color: #fff;
  width: 6em;
  height: 2.8em;
  font-size: 14px;
  max-width: 27%;
}
.zc-btn span {
  line-height: 1.4;
}
.zc-list-group {
  height: calc(100vh - 280px);
  overflow: auto;
}
.zc-list-group .tr {
  border-bottom: 1px solid #e5e5e5;
  padding: 15px 0;
  font-size: 14px;
  color: #050505;
}
.zc-list-group .tr .td {
  width: 30%;
}
</style>


// WEBPACK FOOTER //
// src/components/Wjtz-component2.vue